import React, { useState, useEffect } from "react";
import useAuth from "../../../hooks/useAuth";

const AboutUs = () => {
  useAuth(); // Ensure the user is authenticated

  // Code start here

  // End

  return (
    <div className="container mt-5">
      <div className='col-md-12'>
        <h4 className="blue add_user_heading">About Us</h4>
      </div>
      <p>
        MarketsandMarkets was founded in 2009 with a simple, yet powerful, idea
        - every disruption is inherently the source of game-changing business
        opportunities. At that time, everybody was talking about disruptive
        trends such as AI, IoT, 3D printing, nanotech, robotics, etc. but nobody
        was certain about the business opportunities associated with them. Upon
        sensing this significant white space, MarketsandMarkets started
        exploring these emerging and fast-growing opportunities and soon
        realized that it was part of a much bigger game. We figured out that the
        B2B economy was just beginning to undergo a dramatic transformation,
        wherein roughly $25 trillion of new revenue sources would emerge by the
        end of 2030. So, we embarked on a journey to help B2B companies monetize
        their play in this phenomenon.
      </p>
      <p>
        During the past 13 years, we got to work with more than 10,000 companies
        and created $140+ billion of revenue impact for them. Consequently, we
        too evolved from being a market research publisher to a growth enabling
        firm. We also moulded our entire corporate culture around "GIVE growth"
        to promote a growth mindset among our 1500+ people workforce. Earlier
        this year, we made a formal transformation into one of America's best
        management consulting firms as per a survey conducted by Forbes -
        evidently as the only India origin startup in the list of 200 firms.
        Even among these 200 peers, we stand apart as a blue-ocean alternative
        because of our unique intellectual property called Knowledge Store - A
        primary research driven AI-enabled market intelligence platform meant
        for growth-minded executives.
      </p>
    </div>
  );
};

export default AboutUs;
